import { type DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { type LegalDocumentGroup } from '@/modules/legalDocuments';
import { OnboardingDataDraft } from '@/modules/rulesEngine';

import { accountSchema } from '../schema/accountSchema';

type FormValues = z.infer<typeof accountSchema>;

// Rebuilds form defaults from the draft. The form's `agreements` record is
// rehydrated by intersecting `draft.signedDocuments` (uuids) with the active
// `legalGroups` catalog: a group counts as checked when its anchor uuid is in
// the signed set. Lets the form restore state when the user navigates away
// and back, and hydrates from `mapUserDataToDraft` on SSO/existing-user load.
export const mapDraftToFormValues = (
  draft: OnboardingDataDraft,
  legalGroups: LegalDocumentGroup[]
): DefaultValues<FormValues> => {
  const signedUuids = new Set(draft.signedDocuments?.map((d) => d.uuid) ?? []);
  const agreements: Record<string, boolean> = {};
  for (const group of legalGroups) {
    if (signedUuids.has(group.anchor.uuid)) agreements[group.anchor.uuid] = true;
  }

  return {
    firstName: draft.firstName ?? '',
    lastName: draft.lastName ?? '',
    email: draft.email ?? '',
    phone: draft.phone ?? '',
    birthday: draft.birthday ?? '',
    password: '', // never prefill from API
    agreements,
    sms: draft?.sms === true,
  } as DefaultValues<FormValues>;
};
